import * as d3 from 'd3';
// import d3 from './d3-import.js';
import Handlebars from 'handlebars';
import api from './api';
import utils from './utils';

const map = {
    manifest: null,
    stateCount: 0,
    mapEl: null,
    statePopup: null,

    // get manifest data and attach listeners
    init: function(){
        api.getManifest().then(res => {
            this.manifest = res.body;
        });
        this.mapEl = document.getElementById('map');
        this.renderMap(this.mapEl);
        document.body.addEventListener('click', function(e){
            if(e.target.classList.value == 'close-card' || (e.target.closest('.profile-card') == null && e.target.closest('path') == null && e.target.closest('circle') == null)){
                if(document.querySelector('.state-popup.open')){
                    document.querySelector('.state-popup.open').classList.remove('open');
                    let mapSvg = document.querySelector('.state-index-map');
                    mapSvg.classList.remove('state-selected');
                    mapSvg.querySelector('.selected').classList.remove('selected');
                }
            }
        });
        window.addEventListener("resize",utils.debounce(function(e){
            let mapEl = document.getElementById('map');
            let mapWidth = mapEl.getBoundingClientRect().width;
            let mapHeight = mapWidth * 0.5625;
            d3.select("#map svg.state-index-map").transition().attr("height", mapHeight).attr("width", mapWidth);
            d3.select("#map svg.legend").transition().attr("height", 24).attr("width", (mapWidth));
        }));
    },

    // get map json data and draw map based on saved geojson' file containing state shapes
    renderMap: function(mapEl){
        if(!mapEl){
            return false;
        }
        let stateMetricsDataUrl = "/wp-json/wp/v2/states?fields=dcwsi_ind_i,wsp_ind_i,dcwe_ind_i";

        let mapWidth = mapEl.getBoundingClientRect().width;
        mapWidth = (mapWidth == 0) ? 790 : mapWidth;
        let mapHeight = mapWidth * 0.5625;

        let projection = d3.geoAlbersUsa()
            .translate([mapWidth/2, mapHeight/2])
            .scale([(mapWidth < 1050 ? mapWidth : (mapWidth*1.2))]);

        let path = d3.geoPath()
            .projection(projection);

        let color = d3.scaleQuantize()
            .domain([1, 51])
            .range(["#1d9ad6","#00b0ab","#dcab27","#d48028"]);

        let legendText = Object.values(JSON.parse(statePercentiles));

        let svg = d3.select(mapEl)
            .append("svg")
            .attr("class", "state-index-map")
            .attr("preserveAspectRatio","xMinYMin")
            .attr("width", mapWidth)
            .attr("height", mapHeight)
            .attr("viewBox", "0 0 " + mapWidth + " " + mapHeight);

        d3.json(stateMetricsDataUrl, (data) => {
            let states = data.data;
            this.stateCount = states.length;
            let geoJson = assetPath+'/us-states.json';
            let mapInsetDC = {
                name: 'District of Columbia',
                coords: projection([-77.03637,38.89511]),
                dcwsi_ind_i: null,
                wsp_ind_i: null,
                dcwe_ind_i: null,
                score_color: null,
                score_tier: null
            };
            d3.json(geoJson, (json) => {
                states.forEach(function(state){
                    for(var i = 0; i < json.features.length; i++){
                        let jsonState = json.features[i].properties.name;
                        if(state.name == jsonState){
                            json.features[i].properties.state_url = state.url;
                            json.features[i].properties.dcwsi_ind_i = state.dcwsi_ind_i;
                            json.features[i].properties.wsp_ind_i = state.wsp_ind_i;
                            json.features[i].properties.dcwe_ind_i = state.dcwe_ind_i;
                            if(jsonState == 'District of Columbia'){
                                mapInsetDC.state_url = state.url;
                                mapInsetDC.dcwsi_ind_i = state.dcwsi_ind_i;
                                mapInsetDC.wsp_ind_i = state.wsp_ind_i;
                                mapInsetDC.dcwe_ind_i = state.dcwe_ind_i;
                            }
                            break;
                        }
                    }
                });

                svg.selectAll("path")
                    .data(json.features)
                    .enter().append("path")
                    .attr("d", path)
                    .style("stroke", "rgba(255,255,255,0.75)")
                    .style("stroke-width", "1")
                    .style("fill", (d,i) => {
                        let score = d.properties.dcwsi_ind_i;
                        if(score){
                            let scoreColor = color(score);
                            let legendIndex = Math.abs(Math.ceil((4*(score/this.stateCount))-(1/this.stateCount)-1));
                            json.features[i].properties.score_color = scoreColor;
                            json.features[i].properties.score_tier = legendText[legendIndex];
                            if(d.properties.name == 'District of Columbia'){
                                mapInsetDC.score_color = scoreColor;
                                mapInsetDC.score_tier = legendText[legendIndex];
                            }

                            return scoreColor;
                        } else {
                            return '#5D6367';
                        }
                    })
                    .on('mouseup', function(d){
                        map.stateClick(this,d.properties);
                    });

                this.statePopup = d3.select(mapEl)
                    .append("div")
                    .attr("class", "state-popup");

                //draw the DC circle to right of map
                // let dcInset = d3.select('.state-index-map')
                //     .append("circle")
                //     .attr("class", "dc-inset")
                //     .attr("cx", mapInsetDC.coords[0])
                //     .attr("cy", mapInsetDC.coords[1])
                //     .attr("r", 12)
                //     .style("fill", mapInsetDC.score_color)
                //     .style("transform", "translate(65px,0)")
                //     .on('mouseup', function(d){
                //         map.stateClick(this,mapInsetDC);
                //     });

                let dcStar = d3.select('.state-index-map')
                    .append("path")
                    .attr("class", "dc-star")
                    .attr("d", "M12,0 L14.58,6.17 L21.12,6.79 L16.47,11.24 L17.68,17.65 L12,14 L6.32,17.65 L7.53,11.24 L2.88,6.79 L9.42,6.17 L12,0")
                    .attr("transform", "translate(" + (mapInsetDC.coords[0] + 65) + "," + (mapInsetDC.coords[1] - 10) + ")")
                    .attr("fill", mapInsetDC.score_color)
                    .style("cursor", "pointer")
                    .on('mouseup', function(d) {
                        console.log('Clicked on the star element');
                        map.stateClick(this, mapInsetDC);
                    });

                d3.select('.state-index-map')
                    .append("text")
                    .data(["Washington D.C."])
                    .attr("x", mapInsetDC.coords[0])
                    .attr("y", mapInsetDC.coords[1])
                    .attr("dy", ".4em")
                    .attr("font-size", "11px")
                    .style("transform", "translate(88px,0)")
                    .text(function(d){
                        return d;
                    });

                //draw color legend
                let legend = d3.select(mapEl)
                    .append("div")
                    .append("div")
                    .attr("class", "legend")
                    .attr("width", (mapWidth*.3))
                    .selectAll(".legend div")
                    .data([13,25,38,51])
                    .enter().append("div");

                legend.append("span")
                    .attr("class", "square")
                    .style("background-color", color);

                legend.append("span")
                    .data(legendText)
                    .text(function(d){
                        return d;
                    });
            });
        });
    },

    //handle state click and display profile popup and position
    stateClick: function(path,data){
        let [clickX, clickY] = d3.mouse(path);
        let pathRect = path.getBoundingClientRect();
        let cardWidth = parseInt(window.getComputedStyle(this.statePopup.node()).getPropertyValue("width").replace("px",""));
        let cardHeight = parseInt(window.getComputedStyle(document.querySelector('.state-popup')).getPropertyValue('min-height').replace("px",""));
        let x = 0;
        if(clickX > (this.mapEl.getBoundingClientRect().width/2)){
            x = parseInt(pathRect.x - this.mapEl.getBoundingClientRect().x - cardWidth - 40);
        } else {
            x = parseInt((pathRect.x - this.mapEl.getBoundingClientRect().x + pathRect.width) + 40);
        }

        let barOffset = document.querySelector('.subscribe-bar') ? document.querySelector('.subscribe-bar').scrollHeight : 0;

        let y = clickY;
        if(this.mapEl.getBoundingClientRect().y > barOffset){
            // map is scrolled within view, calculate to center of state
            if(pathRect.y + (pathRect.height/2) > (cardHeight/2)){
                y = parseInt(pathRect.y + (pathRect.height/2) - ((cardHeight/2) - barOffset));
            } else {
            // upper states just use card height/2
                y = parseInt(cardHeight/2);
            }
        } else if(this.mapEl.getBoundingClientRect().y > 0){
            // map is behind newsletter bar, need to handle offset to keep card visible
            if(pathRect.y + (pathRect.height/2) - (barOffset - this.mapEl.getBoundingClientRect().y) > (cardHeight/2)){
                y = parseInt(pathRect.y + (pathRect.height/2) - (barOffset - this.mapEl.getBoundingClientRect().y));
            } else {
                y = parseInt((cardHeight/2) + barOffset);
            }
        } else {
        // map is only partially visible, try to keep card visible and as close to aligned with state center as is reasonable
            if(pathRect.y + (pathRect.height/2) - (barOffset + this.mapEl.getBoundingClientRect().y) > (cardHeight/2)){
                y = parseInt((barOffset - this.mapEl.getBoundingClientRect().y) + pathRect.y + (pathRect.height/2));
            } else {
                y = parseInt((barOffset - this.mapEl.getBoundingClientRect().y) + (cardHeight/2) + ((pathRect.y > barOffset) ? (pathRect.y - (pathRect.height/2)) : (pathRect.y - (pathRect.height/2) + (barOffset - pathRect.y))));
            }
        }

        let mapSvg = document.querySelector('.state-index-map');
        mapSvg.classList.add('state-selected');
        if(mapSvg.querySelector('.selected')){
            mapSvg.querySelector('.selected').classList.remove('selected');
        }
        path.classList.add('selected');
        let stateProfileData = this.stateProfileData(data);
        let profileCard = this.stateProfileCard(stateProfileData);
        this.statePopup.html(profileCard)
            .style('left', `${x}px`)
            .style('top', `${y}px`)
            .attr("class", "state-popup open");
    },

    //gets each statedate formatted for profile from passed click event
    stateProfileData: function(data){
        let parentKey = Object.keys(this.manifest)[0];
        let metrics = this.manifest[parentKey].children;
        let profileData = {
            stateName: data.name,
            stateRank: data[parentKey],
            stateCount: this.stateCount,
            statePercentileColor: data.score_color,
            statePercentileName: data.score_tier,
            metrics: [],
            stateLink: data.state_url
        };
        for(var key in metrics){
            profileData.metrics.push({
                metricName: metrics[key].name,
                metricRank: data[key],
                metricCount: this.stateCount
            });
        }

        return profileData;
    },

    // rendered prfoile card with handlebars
    stateProfileCard: function(stateData){
        let template = document.getElementById('stateProfileCard').innerHTML;
        let card = Handlebars.compile(template);

        return card(stateData);
    },
};

export default map;
